
import { getPhoneTopStyle } from '@/composables/fxwallet'
import config from '@/config'
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    skinImage: {
      type: String,
      default: config.skinImage
    }
  },

  setup () {
    const { phoneStyle } = getPhoneTopStyle()

    return {
      phoneStyle,
      publicPath: process.env.BASE_URL
    }
  }
})
